<template>
    <div class="g">
        <mdSearch>
            <cpDatePicker
                type="date"
                :errorStatus="errors.has('startDate')"
                :errorMsg="errors.first('startDate')"
                v-model="startDate"
                v-validate="'required'"
                :label="$t('site.noun.startdate')"
                name="startDate"
                ref="startDate"
            ></cpDatePicker>
            <cpDatePicker
                type="date"
                :errorStatus="errors.has('endDate')"
                :errorMsg="errors.first('endDate')"
                v-model="endDate"
                v-validate="'required|equalAfter:'+ startDate"
                :label="$t('site.noun.enddate')"
                name="endDate"
                ref="endDate"
            ></cpDatePicker>
            <cpBtn
                icon="get_app"
                :text="$t('site.noun.load')"
                @click.prevent="search"
            ></cpBtn>
        </mdSearch>
        <gRow class="board">
            <gCell
                v-for="item in boards"
                :key="item.prop"
            >
                <mdInfoBoard
                    :caption="item.name"
                    :text="item.num"
                    :active="activeTab === item.prop"

                    @click="changeTab(item.prop)"
                ></mdInfoBoard>
            </gCell>
        </gRow>
        <gTable
            :table="table"
            :haveSearch="true"
            :fixedHeader="false"
            :setTitle="true"
            :havePageination="table.content && table.content.length > 10"
            :pageSet="page"
            :pageFunc="pageFunc"

            @sendEvent="receiveEvent"
        >
            <gAll
                v-if="tab === 1 || tab === 2 || tab === 3"
                slot="bottom"

                :obj="totalData"
            ></gAll>
        </gTable>
    </div>
</template>

<script>
    import mdSearch from '@/components/mdSearch'
    import mdInfoBoard from '@/components/mdInfoBoard'
    import gRow from '@/components/gRow'
    import gCell from '@/components/gCell'
    import gTable from '@/components/gTable'
    import gAll from '@/components/gAll'
    import cpDatePicker from '@/components/cpDatePicker'
    import cpBtn from '@/components/cpBtn'

    import { mapGetters, mapMutations,mapState } from 'vuex'
    import { Decimal } from 'decimal.js';

    export default {
        components: {
            mdSearch,
            mdInfoBoard,
            gRow,
            gCell,
            gTable,
            gAll,
            cpDatePicker,
            cpBtn,
        },
        data: function(){
            let $time = new Date(),
                _year = $time.getFullYear(),
                _month = $time.getMonth() + 1,
                _date = $time.getDate(),
                _endDate = _year +'-'+ this.$okaTool.doubleCount(_month) +'-'+ this.$okaTool.doubleCount(_date);

            let $startDate = this.$okaTool.timeInterval({
                    unit: 'm',
                    away: '<',
                    time: _endDate,
                    int: 1
                }),
                _startDate = $startDate.ymd;

            let $query = this.$route.query || {},
                _start = $query.start,
                _end = $query.end;

            if( _start ) {
                _startDate = _start;
            }
            
            if( _end ) {
                _endDate = _end;
            }

            let $list = [
                    {
                        prop: 'inquiry',
                        name:this.$t('page.myorders.name.inquiry'),
                    },
                    {
                        prop: 'quotation',
                        name:this.$t('page.myorders.name.quotation'),
                    },
                    {
                        prop: 'orderwaitforconfirm',
                        name:this.$t('page.myorders.name.confirmed'),
                    },
                    {
                        prop: 'ordercomplete',
                        name:this.$t('page.myorders.name.shipping'),
                    },
                    {
                        prop: 'ordercancel',
                        name:this.$t('page.myorders.name.cancelled'),
                    },
                ]

            return {
                time: $time,
                list: $list,
                startDate: _startDate,
                endDate: _endDate,
                table: {},
                board: {},
                coaRef: {},
            }
        },
        computed: {
            ...mapState([
                'user',
            ]),
            ...mapGetters([
                'division'
            ]),
            isTax: function(){ //是否有5%營業稅
                let $user = this.user

                //https://www.notion.so/84092b92b33d47bd99f34da8b905b7a1
                if($user.cukd === 'E' || $user.cukd === 'B'){
                    return  false
                }

                return true
            },
            totalData: function(){
                let $table = this.table,
                    $content = $table.content || []

                let $result = []

                let $ref = {
                        totalprice: this.$t('page.mypurchases.item.subtotal'),
                    }
                    
                if( this.isTax ) { //有睡的客戶
                    $ref['totalpriceAfterTax'] = (this.$t('page.mypurchases.item.subtotal') + this.$t('page.shoppingcart.func.tax'));
                }

                let $key = Object.keys($ref),
                    $values = {}

                $key.forEach(key => {
                    $values[key] = new Decimal(0);
                });

                $content.forEach(content => {

                    if( content.show ) {

                        $key.forEach(key => {
                            let _value = content[key]

                            if( typeof _value === 'string' ) {
                                _value = _value.replaceAll(',', '');
                            }

                            let $value = new Decimal(_value);

                            $values[key] = $values[key].add($value);
                        });
                    }
                });

                $key.forEach(key => {

                    $result.push({
                        caption: $ref[key],
                        content: this.$okaTool.numberToStringFormat($values[key].toFixed(10)),
                    })
                });
                
                return $result;
            },
            query: function(){
                return this.$route.query || {}
            },
            tab: function(){
                let _tab = this.query.tab || 0;

                return parseInt(_tab);
            },
            page: function(){
                let _result = this.query.table || 1;

                return parseInt(_result);
            },
            start: function(){
                return this.query.start || this.startDate;
            },
            end: function(){
                return this.query.end || this.endDate;
            },
            activeTab: function(){
                let $list = this.list,
                    _active = this.tab,
                    $target = $list[_active]

                return $target.prop;
            },
            boards: function(){
                let $list = this.list,
                    $board = this.board,
                    $result = []

                $list.forEach(item => {

                    $result.push({
                        name: item.name,
                        prop: item.prop,
                        num: $board[item.prop] || 0,
                    });
                });

                return $result;
            },
        },
        watch: {
            tab: {
                handler: function(){
                    this.init();
                }
            },
        },
        methods: {
            ...mapMutations([
                'catchError',
                'pushPopUp',
                'pushNotification',
                'buyAgain',
            ]),
            pageFunc: function(page){
                this.$router.push('/system/account?page=purchase&tab='+ this.tab +'&table='+ page +'&start='+ this.start +'&end='+ this.end);
            },
            show: function(opt){
                this.$router.push('/system/orderInfo?inqtno='+ opt.inqtno +'&type='+ this.tab);
            },
            search: function(){
                this.$router.push('/system/account?page=purchase&tab='+ this.tab +'&table=1&start='+ this.startDate +'&end='+ this.endDate);
                this.init();
            },
            showPayNotify: function(opt){
                let _html = this.$t('popup.payment.func.alert',{ odno: opt.inqtno}) 
                this.pushPopUp({
                    type: 'alert',
                    content: {
                        caption:  this.$t('page.orderhistory.status.nopay'),
                        html: _html,
                    }
                })
            },
            addAgain: function(opt){
                this.buyAgain(opt.inqtno);
            },
            removeCore: async function(opt){
                let _url = this.$siteTool.apiUrl({
                        class: 'Order',
                        func: 'CancelOrder',
                    }),
                    $condition = {
                        inqtno: opt.inqtno
                    }

                try {
                    await this.$http.post(_url, $condition);

                    this.pushNotification({
                        type: 'notification',
                        content: {
                            html: this.$t('site.status.removesuccess'),
                            status: 'success'
                        }
                    });

                    this.init();
                    
                }catch(error) {

                    this.catchError({
                        error: error,
                        callback: () => {
                            this.removeCore(opt);
                        },
                    });
                }
            },
            quotationDownload: function(opt){
             
                let _url = this.$siteTool.apiUrl({
                        class: 'Quotation',
                        func: 'Download',
                    }),
                    $condition = {
                        inqtno: opt.inqtno,
                    }

                this.$http.post(_url, $condition,{ responseType: 'blob' }).then(res=>{
                    this.$siteTool.download(res)
                }).catch(error => {

                    this.catchError({
                        error: error,
                        callback: () => {
                            this.quotationDownload(opt)
                        },
                    });
                })
            },
            coaDownload: function(opt){
                let $_downLoad = (lang) => {
                    let _url = this.$siteTool.apiUrl({
                            class: 'COA',
                            func: 'Download',
                        }),
                        $condition = {
                            inqtno: opt.inqtno,
                            language: lang
                        }

                    this.$http.post(_url, $condition,{ responseType: 'blob' }).then(res=>{
                        this.$siteTool.download(res)
                    }).catch(error => {

                        this.catchError({
                            error: error,
                            callback: () => {
                                this.coaDownload(opt)
                            },
                        });
                    })
                }

                this.pushPopUp({
                    type: 'showSelect',
                    content: {
                        caption: this.$t('page.myorders.func.downloadcoa'),
                        showNull: false,
                        value: 'zh',
                        options:{
                            en: 'English',
                            zh: '繁體中文',
                        },
                        action: (value) =>{
                            $_downLoad(value)
                        }
                    }
                })
                
            },
            receiptDownload: function(opt){
             
                let _url = this.$siteTool.apiUrl({
                        class: 'Invoice',
                        func: 'Download',
                    }),
                    $condition = {
                        odno: opt.odno,
                    }

                this.$http.post(_url, $condition,{ responseType: 'blob' }).then(res=>{
                    this.$siteTool.download(res)
                }).catch(error => {

                    this.catchError({
                        error: error,
                        callback: () => {
                            this.receiptDownload(opt)
                        },
                    });
                })
            },
            remove: function(opt){
                let _html = this.$t('page.myorders.status.cancelorder');

                //20220208 新增確認中訂單取消功能 
                if(this.tab == 0 ) {
                    _html = this.$t('page.myorders.status.cancelinquiry');
                }

                this.pushPopUp({
                    type: 'confirm',
                    content: {
                        html: _html ,
                        action: () => {
                            this.removeCore(opt);
                        }
                    }
                });
            },
            // send: async function(opt){
            //     let _url = this.$siteTool.apiUrl({
            //             class: 'Order',
            //             func: 'SendQuotation',
            //         }),
            //         $condition = {
            //             inqtno: opt.inqtno
            //         }

            //     try {
            //         await this.$http.post(_url, $condition);

            //         this.pushNotification({
            //             type: 'notification',
            //             content: {
            //                 html: this.$t('site.status.ordersuccess'),
            //                 status: 'success'
            //             }
            //         });

            //         this.init();
                    
            //     }catch(error) {

            //         this.catchError({
            //             error: error,
            //             callback: () => {
            //                 this.removeCore(opt);
            //             },
            //         });
            //     }
            // },
            changeTab: function(opt){
                let $list = this.list,
                    _active = this.tab,
                    $target = $list.find(item => item.prop === opt),
                    _index = $list.indexOf($target);

                if( _active !== _index ) {
                    this.$router.push('/system/account?page=purchase&tab='+ _index);
                }
            },
            initBoard: function(res){ //init 取回來的資料
                this.$set(this, 'board', res);
            },
            getBoard: function(){ //init 畫面的時候要先取得資料
                let _url = this.$siteTool.apiUrl({
                        class: 'Order',
                        func: 'Indicator',
                    }),
                    $condition = {
                        startdate: this.start,
                        enddate: this.end,
                    }

                return this.$http.post(_url, $condition);
            },
            initTable: function(res){ //init 取回來的資料
                let $data = res || {},
                    $content = $data.content || [],
                    $title = $data.title || []
                    
                let $user = this.user,
                    _codiv = $user.co +''+ $user.div;

                let _active = this.tab;

                let $show = {
                        text: '',
                        themes: 'success',
                        icon: 'visibility',
                        func: 'show',
                        extendClass: 'is-major is-hover',
                        title:this.$t('page.myorders.func.showmore'),

                    },
                    $remove = {
                        text: '',
                        themes: 'cancel',
                        icon: 'delete_outline',
                        func: 'remove',
                        extendClass: 'is-cancel is-hover',
                        title:this.$t('page.myorders.func.cancelinquiry'),
                    },
                    // $send = {
                    //     text: '',
                    //     themes: 'send',
                    //     icon: 'done',
                    //     func: 'send',
                    //     extendClass: 'is-major is-hover',
                    //     title:this.$t('page.myorders.func.ordernow'),
                    // },
                    $addAgain = {
                        text: '',
                        themes: 'again',
                        icon: 'shopping_cart',
                        extendClass: 'is-major is-hover',
                        func: 'addAgain',
                        title: this.$t('product.myorders.func.buyagain'),
                    },
                    $payNotify = {
                        text: '',
                        themes: 'danger',
                        icon: 'error',
                        extendClass: 'is-danger is-icon',
                        func: 'showPayNotify',
                        title: this.$t('page.orderhistory.status.nopay'),
                    },
                    $receipt = {
                        text: '',
                        themes: 'forth',
                        icon: 'payments',
                        extendClass: 'is-hover',
                        func: 'receiptDownload',
                        title: this.$t('page.myorders.func.downloadinvoice'),
                    },
                    $coa = {
                        text: '',
                        themes: 'coa',
                        icon: 'colorize',
                        extendClass: 'is-major is-hover',
                        func: 'coaDownload',
                        title: this.$t('page.myorders.func.downloadcoa'),
                    },
                    $download = {
                        text: '',
                        themes: 'warning',
                        icon: 'article',
                        extendClass: 'is-major is-hover',
                        func: 'quotationDownload',
                        title: this.$t('page.myorders.func.downloadquotation'),
                    }

                if( this.division == 'TRL' ) {
                    let $adcuabr = $title.find(item => item.prop === 'adcuabr');

                    if( $adcuabr ) {
                        let _index = $title.indexOf($adcuabr);

                        $title.splice(_index, 1);
                    }
                }

                if( _active === 1 || _active === 2 || _active === 3 || _active === 4 ){
                    
                    if( this.isTax ) { //有睡的客戶
                        let $totalprice = $title.find(item => item.prop === 'totalprice');

                        if( $totalprice ) {
                            let _index = $title.indexOf($totalprice),
                                $totalpriceAfterTax = this.$okaTool.copy($totalprice)

                            $totalpriceAfterTax.prop = 'totalpriceAfterTax';
                            $totalpriceAfterTax.caption += this.$t('page.shoppingcart.func.tax');

                            $title.splice(_index + 1, 0, $totalpriceAfterTax);
                        }
                    }
                }

                if( _active === 3 || _active === 4 ){

                    $title.push({  //交運率只出現在出貨 & 取消
                        caption: this.$t('page.myorders.caption.deliveryrate'),
                        prop: 'deliveryrate',
                        showtype: 'label',
                        sortable: true,
                        sort: '',
                        searchable: false,
                        inputtype: '',
                        visible: true,
                        themes: 'danger',
                    });
                }

                $title.push({
                    caption: this.$t('page.myorders.caption.settings'),
                    prop: 'func',
                    showtype: 'btns',
                    sortable: false,
                    sort: '',
                    searchable: false,
                    inputtype: '',
                    visible: true
                });

                $content.forEach((data, _index) => { //init

                    if( _active === 1 || _active === 2 || _active === 3 || _active === 4 ){
                    
                        if( this.isTax ) { //有睡的客戶
                            let $totalprice = new Decimal(data.totalprice),
                                $totalpriceAfterTax = $totalprice.mul(new Decimal(1.05)),
                                _totalpriceAfterTax = parseFloat($totalpriceAfterTax.toFixed(10), 10);

                            data.totalpriceAfterTax = this.$okaTool.numberToStringFormat(_totalpriceAfterTax);
                        }
                    }

                    if( _active === 3 || _active === 4 ){
                        let _deliveryrate = data.totalacdlqty / data.totalqty * 100; //交運率

                        if( _deliveryrate >= 100 ) {

                            data.extend = {
                                themes: {
                                    deliveryrate: 'info'
                                }
                            }
                        }

                        data.deliveryrate = this.$okaTool.numberToStringFormat(_deliveryrate, 0) + '%';
                    }

                    data.totalprice = this.$okaTool.numberToStringFormat(data.totalprice);
                    data.totalqty = this.$okaTool.numberToStringFormat(data.totalqty);
                    data.totalacdlqty = this.$okaTool.numberToStringFormat(data.totalacdlqty);

                    data.iq_startdate = data.iq_startdate * 1000;
                    data.aodate = data.aodate * 1000;
                    data.qt_startdate = data.qt_startdate * 1000;
                    data.qt_enddate = data.qt_enddate * 1000;
                    data.placeorderdate = data.placeorderdate * 1000;
                    data.canceldate = data.canceldate * 1000;

                    if( _active == 0 ) {

                        data.func = [
                            $show,
                            $remove,
                        ]
                    }else if( _active == 1 ) {

                        data.func = [
                            $show,
                            $remove,
                            $download,
                            // $send,
                        ]
                    }else if( _active == 2 ) {
                        data.func = [
                            $show,
                            $remove,
                            $download,
                        ]

                        //20220208 新增確認中訂單取消功能 
                        if( data.issendremit ){ //20220329若有被通知附款過，就顯示驚嘆號
                            data.func.push($payNotify)
                        }
                    }else if( _active == 3 ) {
                        
                        data.func = [
                            $show,
                            $addAgain,
                            $download,
                        ]

                        if( data.inv_available ){
                            data.func.push($receipt);
                        }

                        if( (_codiv == '11' || _codiv == '18' || _codiv == '1p') && data.totalacdlqty != 0 ) {
                            data.func.push($coa);
                        }else if( _codiv == '14' ) {

                            if( this.coaRef[data.inqtno] ) { //如果coa可以下載
                                data.func.push($coa);
                            }
                        }
                    }else if( _active == 4 ) {
                        
                        data.func = [
                            $show,
                            $addAgain,
                        ]

                        if( data.inv_available ){
                            data.func.push($receipt);
                        }
                    }

                    data.show = true;
                });

                this.$set(this, 'table', $data);
            },
            getTable: function(){ //init 畫面的時候要先取得資料
                let _url = this.$siteTool.apiUrl({
                        class: 'Order',
                        func: 'List',
                    }),
                    $condition = {
                        startdate: this.start,
                        enddate: this.end,
                        type: this.tab,
                    }

                return this.$http.post(_url, $condition);
            },
            getCoaRef: function(array){ //init 畫面的時候要先取得資料
                let _url = this.$siteTool.apiUrl({
                        class: 'CoaCheck',
                    }),
                    $condition = {
                        nos: array.map(item => item.inqtno)
                    }

                return this.$http.post(_url, $condition);
            },
            initCoaRef: function(res, callback){ //init 取回來的資料
                let $data = res || [],
                    $result = {}

                $data.forEach(item => {
                    $result[item.no] = item.can_download;
                });

                this.$set(this, 'coaRef', $result);

                if( typeof callback === 'function' ) {
                    callback();
                }
            },
            init: async function(){

                if(this.start > this.end ){

                }else{

                    try {
                        let $response = await Promise.all([
                                this.getTable(),
                                this.getBoard(),
                            ]);

                        let [table, board] = $response;
                    
                        let $user = this.user,
                            _codiv = $user.co +''+ $user.div;

                        if( _codiv == '14' && this.tab == 3 && table.content && table.content.length > 0 ) {
                            let $responseForCoaRef = await this.getCoaRef(table.content);

                            this.initCoaRef($responseForCoaRef, () => {
                                this.initTable(table);
                            });
                        }else {
                            this.initTable(table);
                        }

                        this.initBoard(board);
                        
                    }catch(error) {

                        this.catchError({
                            error: error,
                            callback: this.init,
                        });
                    }
                }
            },
        },
        created: function(){
            this.init();
        }
    }
</script>

<style scoped lang="scss">

    .is-error{
        background-color: #fff;
    }

    .board {

        @include media('mobile') {
            display: flex !important;
        }

        &::v-deep {

            .g.cell {
                flex: 1 !important;
            }
        }
    }

    .g {

        &::v-deep {

            .md.search {
                
                @include media('phone') {
                    padding-right: 40px;
                }
            }
        }
    }
</style>
